import { render, staticRenderFns } from "./BpmAutoDesformApply.vue?vue&type=template&id=6b421b2a&scoped=true&"
import script from "./BpmAutoDesformApply.vue?vue&type=script&lang=js&"
export * from "./BpmAutoDesformApply.vue?vue&type=script&lang=js&"
import style0 from "./BpmAutoDesformApply.vue?vue&type=style&index=0&id=6b421b2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b421b2a",
  null
  
)

export default component.exports